module.exports = __webpack_public_path__ + "img/withdraw.797c857a.svg";